module.exports = __webpack_public_path__ + "static/media/capsule.7451546c.svg";